import { IconButton } from "@chakra-ui/button"
import { Box } from "@chakra-ui/layout";
import { Tooltip } from "@chakra-ui/tooltip";
import { ExternalLinkIcon } from "lib/icons/externalLink"
import { FC } from "react";
import { IconButtonProps } from "@chakra-ui/react";

export const IconButtonExternalLink: FC<Partial<IconButtonProps>> = (props) => (
    <Tooltip
      label="Open"
      openDelay={600}
      closeOnMouseDown
      hasArrow
    >
    <Box>
      <IconButton variant="primary" size="sm" aria-label="Open external link" {...props}>
        <ExternalLinkIcon boxSize="16px" />
      </IconButton>
    </Box>
  </Tooltip>
);
